export const RESPONDENT = '[Respondent]';

export const START_JOURNEY_SAGA = `${RESPONDENT} START_JOURNEY_SAGA`;
export const SUBMIT_JOURNEY_SAGA = `${RESPONDENT} SUBMIT_JOURNEY_SAGA`;
export const SET_IS_SUBMIT_MODAL_OPEN = `${RESPONDENT} SET_IS_SUBMIT_MODAL_OPEN`;
